import React, { memo } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useLanguage } from '../../../../../../../contexts/LanguageContext';
import { useClientSideSort } from '../../../../hooks/useClientSideSort';

const formatDate = (date) => (!date ? '-' : new Date(date).toLocaleDateString('tr-TR'));

const ChassisDetailPartListTable = ({ rows = [], loading = false }) => {
    const { th } = useLanguage();
    const { sortedData, sortField, sortOrder, onSort } = useClientSideSort(rows);

    const renderCell = (rowData, field) => {
        const value = rowData[field];
        return value === null || value === undefined || value === '' ? '-' : value;
    };

    return (
        <DataTable
            value={sortedData}
            className="p-datatable-gridlines"
            showGridlines
            paginator
            rows={5}
            onSort={onSort}
            sortField={sortField}
            sortOrder={sortOrder}
            dataKey="id"
            loading={loading}
            emptyMessage={th('warrantyClaims.detail.partTable.noRecordsFound')}
            rowsPerPageOptions={[5, 10, 25, 50]}
            tableStyle={{ minWidth: '40rem' }}
        >
            <Column field="selectType" header={th('warrantyClaims.detail.otherCosts.selectType')} sortable />
            <Column field="description" header={th('warrantyClaims.detail.otherCosts.description')} sortable body={(rowData) => renderCell(rowData, 'description')} />
            <Column field="partQuantity" header={th('warrantyClaims.detail.otherCosts.partQuantity')} sortable body={(rowData) => renderCell(rowData, 'partQuantity')} />
            <Column field="hour" header={th('warrantyClaims.detail.otherCosts.hour')} sortable body={(rowData) => renderCell(rowData, 'hour')} />
        </DataTable>
    );
};

export default memo(ChassisDetailPartListTable);
